module.exports = __webpack_public_path__ + "static/media/kauvery_image_latest.88247f00.jpg";